import { createContext } from 'react';

/**
 * Este contexto es necesario para resolver el problema de que no se muestra
 * la etiqueta correcta cuando la tabla está cargando.
 */
export const TableLoadingContext = createContext<{ current: boolean }>({
  current: true,
});
